<script>
import gql from "graphql-tag";
import { tournamentMainFragment } from "@/graphql/tournament";
import { DialogInputTypes } from "@/js/helper";
import BaseUpsertDialog from "./baseUpsertDialog.vue";
import { Sports } from "@/js/helper";

export default {
  name: "UpsertTournamentDialog",
  extends: BaseUpsertDialog,
  props: { tournament: Object },

  data: function() {
    return {
      entityName: "tournament",
      name: {
        label: "Tournament name",
        required: true
      },
      description: {
        label: "A Short description"
      },
      regulations: {
        label: "Instructions, regulations, etc,",
        multiline: true
      },
      location: {
        label: "Location of the tournament",
        options: []
      },
      circuit: {
        label: "Circuit, league, etc."
      },
      sport: {
        label: "Sport",
        options: Sports.map(x => {
          return {
            value: x.name
          };
        })
      },
      startDate: {
        label: "Start date",
        type: DialogInputTypes.datetime,
        required: true
      },
      endDate: {
        label: "End date",
        type: DialogInputTypes.datetime,
        required: true
      }
    };
  },
  computed: {
    dialogInputs: {
      get() {
        return [
          this.name,
          this.description,
          this.regulations,
          this.location,
          this.circuit,
          this.sport,
          this.startDate,
          this.endDate
        ];
      }
    },
    currentUser: {
      get() {
        return this.$store.state.currentUser;
      }
    },
    entity: {
      get() {
        return this.tournament;
      }
    }
  },

  apollo: {
    locations: {
      query: gql`
        query {
          locations {
            id
            name
          }
        }
      `,
      result({ data, loading, networkStatus }) {
        this.location.options = data.locations.map(x => {
          return { value: x.id, display: x.name };
        });
      },
      skip() {
        return !this.currentUser;
      }
    }
  },

  methods: {
    locationOptions() {
      return this.locations.map(x => {
        return { value: x.id, display: x.name };
      });
    },
    submit() {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation($tinput: TournamentInput!) {
              upsertTournament(tournament: $tinput) {
                ...TournamentMain
              }
            }
            ${tournamentMainFragment}
          `,
          variables: {
            tinput: {
              id: this.tournament && this.tournament.id,
              name: this.name.value,
              description: this.description.value,
              regulations: this.regulations.value,
              locationId: this.location.value,
              circuit: this.circuit.value,
              sport: this.sport.value,
              startDate: this.startDate.value,
              endDate: this.endDate.value
            }
          }
        })
        .then(result => {
          const t = result.data.upsertTournament;
          this.$root.$emit("updateTournament", t.id);
          this.$store.commit(
            "setNotification",
            `${this.tournament ? "Updated" : "Created"} tournament ${t.name}`
          );
          this.$store.commit("pushToRecentTournamentId", {
            id: t.id,
            name: t.name
          });
          this.$router.push({ path: "/tournament" });
        })
        .catch(err => {
          console.log(err);
          window.alert("Failed to update tournament");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// upsertTournamentDialog.vue?6a3f15e6